module.exports = "<div class=\"spinner-background\">\r\n    <div class=\"spinner-window border-gradient-2\">\r\n        <div class=\"spinner-container window-gradient\">\r\n            <div class=\"spinner\">\r\n                <div class=\"spinner-dummy\"></div>\r\n            </div>\r\n            <p class=\"spinner-text\">{{loadingText}}</p>\r\n        </div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./App/Components/ui-spinner.component.html
// module id = 559
// module chunks = 1